import React, { useEffect } from 'react';
import LanguageHandle from '../../types/LanguageHandle';
import { Navigation, NavigationGroup } from '@ktr/ktr-materialui-react';
import { ClampexType } from '../../types/types';
import { Select, makeStyles, createStyles, Theme, MenuItem, Grid } from '@material-ui/core';
import { FormattedHTMLMessage } from 'react-intl';

export interface OwnNavigationProps {
    navBarButtons: Array<NavigationGroup>,
    languageHandle?: LanguageHandle
}

export interface NavigationProps {
    title: string,
    currentClampexType: ClampexType,
    children?: React.ReactNode
}

type Props = OwnNavigationProps & NavigationProps;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        productSelect: {
            marginRight: "10px",

            '&:before': {
                border: "none",
            },
            '&:hover:before': {
                border: "none",
            },
            '&:hover:not(.Mui-disabled):before': {
                border: "none"
            }
        },
        selectInput: {
            color: "#ffffff",
        }, 
        grid1:{
            width: "180px",
            marginTop: "5px",
            fontSize: "1.1em",
            textAlign: "right"
        }
    }),
);

const ClampexNavigation: React.FC<Props> = (props) => {
    const classes = useStyles();
    const [currentClampexType, setCurrentClampexType] = React.useState(ClampexType[props.currentClampexType]); //This state is only for the initial state of the dropdown for product change
    

    //everytime the product changes change also the currentClampexType
    useEffect(() => {
        setCurrentClampexType(ClampexType[props.currentClampexType]);
    }, [props.currentClampexType])

    //on product change navigate to the new product site
    const onProductChange = (e: any) => {
        console.log("VALUE",e.target.value);
        var link = window.document.createElement('a');
        link.href = "#/" + e.target.value;
        document.body.appendChild(link);
        //open url in new window 
        link.click();
        //remove link element from body
        document.body.removeChild(link);
        //Page refresh
        //@ts-ignore
        setTimeout(function(){
            window.location.reload();
          });
        

    }

    return (
        <Navigation navBarButtons={props.navBarButtons} title={props.title}>
           
                <Grid container>
                    <Grid item xs={6} className={classes.grid1}>
                        <FormattedHTMLMessage id="app.labelSpannelement" />:&nbsp;
                    </Grid>
                    <Grid  item xs={6}>
                        <Select inputProps={{ className: classes.selectInput }} value={currentClampexType} onChange={onProductChange} className={classes.productSelect}>
                            {Object.keys(ClampexType).map((key, index) => {
                                //@ts-ignore
                                return <MenuItem key={index} value={ClampexType[key]}>{ClampexType[key]}</MenuItem>
                            })
                            }
                        </Select>
                    </Grid>
                </Grid>
        </Navigation>
    )
}
export default ClampexNavigation;